import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { AreaService } from '@fi-app/area/area.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { AreaDeleteComponent } from '@fi-app/area/area-delete/area-delete.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAreaDeleteState: Ng2StateDeclaration = {
    name: FiStateNames.Area.Delete,
    url: '/Delete/:Id',
    views: {
        '@': {
            component: AreaDeleteComponent,
        },
    },
    resolve: {
        area: [FiStateService, AreaService, Transition, FiAreaDeleteStateResolve_area],
        pageTitle: [PageTitleService, 'area', FiAreaDeleteStateResolve_pageTitle],
    },
};

export function FiAreaDeleteStateResolve_area(
    fiStateService: FiStateService,
    areaService: AreaService,
    $transition$: Transition,
) {
    return areaService.GetArea(fiStateService.getParams($transition$).Id);
}

export function FiAreaDeleteStateResolve_pageTitle(ccmPageTitle: PageTitleService, area) {
    return ccmPageTitle.setTitleByItem(area);
}
